var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrograms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Programs"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Programs",
    clipPath: "url(#clip-Programs)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_592",
    "data-name": "Group 592",
    transform: "translate(22 59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M40,1.327C18.9,1.327,1.635,16.9,1.635,35.989V253.917c0,19.09,17.266,34.739,38.369,34.739H417.793c21.131,0,38.369-15.65,38.369-34.739V35.989c0-19.09-17.237-34.662-38.369-34.662Zm188.952,50c57.181,0,103.71,42.008,103.71,93.638s-46.529,93.742-103.71,93.742-103.739-42.06-103.739-93.716,46.558-93.664,103.739-93.664Zm0,13.684c-23.493-.034-46.035,8.376-62.655,23.376s-25.952,35.356-25.936,56.579c-.03,21.23,9.29,41.6,25.9,56.613s39.159,23.44,62.659,23.42c23.5.014,46.032-8.415,62.64-23.429s25.924-35.378,25.894-56.6c.038-21.223-9.277-41.586-25.889-56.593S252.42,64.951,228.927,64.986ZM195.569,95.276a8.146,8.146,0,0,1,4.266,1.267l67,42.887a6.484,6.484,0,0,1,0,11.149l-67.059,42.887a8.277,8.277,0,0,1-7.877.487,6.8,6.8,0,0,1-4.092-6.1V102.13a6.541,6.541,0,0,1,2.263-4.91,8.037,8.037,0,0,1,5.468-1.97Zm31.5,214.437c-22.191,0-40.373,16.451-40.373,36.5,0,20.073,18.182,36.472,40.373,36.472,22.219,0,40.373-16.4,40.373-36.472,0-20.047-18.154-36.472-40.373-36.472Zm0,27.419c5.841,0,10.05,3.828,10.05,9.079s-4.209,9.105-10.022,9.105c-5.87,0-10.108-3.828-10.108-9.105s4.238-9.105,10.079-9.105ZM172.2,338.916l-164.155.466C3.859,339.4.474,342.477.49,346.262s3.426,6.843,7.616,6.829l163.926-.517a44.4,44.4,0,0,1-.487-6.363A43.838,43.838,0,0,1,172.2,338.916Zm273.821.466-164.012.1a43.861,43.861,0,0,1,.573,6.725,47.01,47.01,0,0,1-.6,6.984l164.041-.1c4.191,0,7.588-3.069,7.588-6.855S450.216,339.382,446.025,339.382Z",
    transform: "translate(-0.49 -1.327)",
    fill: "#6e2b69"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrograms);
export default __webpack_public_path__ + "static/media/Programs.a2709c09544ac73b0fd72eef260a4a20.svg";
export { ForwardRef as ReactComponent };